export const PreferenceKeys = {
    MUSIC_ENABLED_KEY: 'MusicEnabled',
};

interface PreferenceStore {
    setValue(key: string, value: string | number | boolean): void;
    getValue(key: string): string;
    hasKey(key: string): boolean;
    deleteKey(key: string): void;
    deleteAll(): void;
    save(): void;
    load(): void;
}
class LocalStoragePlayerPrefs implements PreferenceStore {
    private static _instance: PreferenceStore;
    static get instance(): PreferenceStore {
        if (!this._instance) {
            this._instance = new LocalStoragePlayerPrefs();
        }
        return this._instance;
    }

    setValue(key: string, value: string | number | boolean): void {
        localStorage.setItem(key, value.toString());
    }
    getValue(key: string): string {
        return localStorage.getItem(key);
    }
    hasKey(key: string): boolean {
        return localStorage.getItem(key) !== null;
    }
    deleteKey(key: string): void {
        localStorage.removeItem(key);
    }
    deleteAll(): void {
        localStorage.clear();
    }
    save(): void {}
    load(): void {}
}
class MemoryPlayerPrefs implements PreferenceStore {
    private static _instance: PreferenceStore;

    private _storage: {[key: string]: string} = {};

    static get instance(): PreferenceStore {
        if (!this._instance) {
            this._instance = new MemoryPlayerPrefs();
        }
        return this._instance;
    }

    setValue(key: string, value: string | number | boolean) {
        this._storage[key] = value.toString();
    }

    getValue(key: string): string {
        return this._storage[key];
    }

    hasKey(key: string): boolean {
        return this._storage.hasOwnProperty(key);
    }
    deleteKey(key: string) {
        delete this._storage[key];
    }
    deleteAll() {
        this._storage = {};
    }

    save(): void {}
    load(): void {}
}

/**
 * PlayerPrefs is a class that allows you to save and load data between game sessions.
 *
 * It seems fairly complex, but this allows to save and load data for every platform
 * (hopefully)
 */
export class PlayerPrefs {
    private static _instance: PlayerPrefs;
    private static get instance(): PlayerPrefs {
        if (!this._instance) {
            this._instance = new PlayerPrefs();
        }
        return this._instance;
    }

    private _store: PreferenceStore;
    private constructor() {
        // Based on the platform, we will use different storage, use in memory for now,
        // but we can change it to use localStorage, or whatever API needed.
        //this._store = MemoryPlayerPrefs.instance;
        this._store = LocalStoragePlayerPrefs.instance;
    }

    static setString(key: string, value: string) {
        this.instance._store.setValue(key, value);
    }
    static getString(key: string, defaultValue: string = ''): string {
        return (this.instance._store.getValue(key) || defaultValue) as string;
    }

    static setNumber(key: string, value: number) {
        this.instance._store.setValue(key, value);
    }
    static getNumber(key: string, defaultValue: number = 0): number {
        const value = this.instance._store.getValue(key);
        return value ? parseFloat(value) : defaultValue;
    }

    static setBool(key: string, value: boolean) {
        this.instance._store.setValue(key, value);
    }
    static getBool(key: string, defaultValue: boolean = false): boolean {
        const value = this.instance._store.getValue(key);
        if (value === 'true') {
            return true;
        } else if (value === 'false') {
            return false;
        }
        return defaultValue;
    }

    static deleteKey(key: string) {
        this.instance._store.deleteKey(key);
    }
    static deleteAll() {
        this.instance._store.deleteAll();
    }

    static hasKey(key: string): boolean {
        return this.instance._store.hasKey(key);
    }
}
